import Navbar from './components/Navbar';
import { FloatingWhatsApp } from "react-floating-whatsapp";
import Footer from './components/Footer';
import { Routes, Route } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import Home from './Pages/Home';
import InvestWithUs from './Pages/InvestWithUs';
import About from './Pages/About';
import Contact from './Pages/Contact';
import FAQs from './Pages/FAQs';
import Reviews from './Pages/Reviews';
import RecentProperties from './Pages/RecentProperties';
import PropertyDetail from './Pages/PropertyDetail';
import { Phone } from 'lucide-react';
import chip from "../public/assets/images/chip.jpg";



const App = () => {
  return (
    <main className="bg-black">
      <Navbar />
      <div className=''>
     
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/our-services" element={<InvestWithUs />} />
          <Route path="/about" element={<About/>} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/recent-properties" element={<RecentProperties />} />
          <Route path="/recent-properties/detail/:id" element={<PropertyDetail />} />
     
        </Routes>
  {/* Floating Call Button */}
<div className="fixed bottom-28 sm:bottom-28 right-8 sm:right-7 z-50">
  
  {/* Animated Ping Background */}
  <div className="absolute inset-0 rounded-full bg-teal-400 animate-ping opacity-70"></div>

  {/* Main Button */}
  <a
    href="tel:+353892256187"
    className="
      relative
      flex items-center justify-center
      w-14 h-14 sm:w-16 sm:h-16
      rounded-full
      bg-teal-600
      text-white
      shadow-[0_10px_40px_rgba(0,0,0,0.35)]
      hover:scale-110
      active:scale-95
      transition-all duration-300
      
    "
  >
    <Phone size={20} className="sm:w-7 sm:h-7" />

    {/* Notification Dot */}
    <span className="absolute top-1 right-1 w-3 h-3 bg-red-500 rounded-full animate-pulse"></span>
  </a>
<FloatingWhatsApp
        phoneNumber="+353 892256187"
        accountName="Ali Constructions"
        avatar={chip}
        statusMessage="Typically replies instantly"
        chatMessage="Hello 👋 How can we help you?"
        placeholder="Type your message..."
        allowEsc
        allowClickAway
        notification
        notificationSound
      />
    

</div>
      <Footer />
      </div>
    </main>
  )
}

export default Sentry.withProfiler(App);
